import { Editor } from "@tiptap/react";
import React, { FC } from "react";
import { IconType } from "react-icons/lib/iconBase";
import { LuRedo as RedoIcon } from "react-icons/lu";
import { SVGReactComponent } from "src/@types";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";

interface Props {
  editor: Editor;
  icon?: IconType | SVGReactComponent;
}

export const RedoButton: FC<Props> = ({ editor, icon: Icon = RedoIcon }) => {
  const onClick = () => editor.chain().focus().redo().run();

  return (
    <Button
      type="button"
      variant={ButtonVariants.SECONDARY}
      className="!rounded-md !duration-100 !p-1"
      onClick={onClick}
    >
      <Icon title="redo" className="w-5 h-5 text-black-base" />
    </Button>
  );
};
